// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Jo-z","itemsContainer":"Ko-z"};